import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function ElderlyMobilitySolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("elderlyMobility.title")}</title>
        <meta name="keywords" content={t("elderlyMobility.keywords")} />
        <meta name="description" content={t("elderlyMobility.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#2a3548]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/elderly-mobility-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_18%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#1a2438]/92 via-[#1a2438]/72 to-[#1a2438]/62" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("elderlyMobility.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("elderlyMobility.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("elderlyMobility.knowledgeBase.rootLabel")}
        rootColor="#7c3aed"
        treeTranslationKey="elderlyMobility.knowledgeBase.tree"
        i18nPrefix="elderlyMobility.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="elderlyMobility"
        images={{
          painPoints: "/solutions/elderly-mobility-pain.jpeg",
          solutions: "/solutions/elderly-mobility-solutions.jpeg",
          cta: "/solutions/elderly-mobility-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 26%",
          solutions: "50% 30%",
          cta: "50% 15%",
        }}
      />
    </>
  );
}
